import React, { useRef } from 'react';
import { Box, Image } from '@leagueplatform/genesis-commons';
import { StackLayout } from '@leagueplatform/web-common-components';
import { useWalletCard } from './hooks/use-wallet-card.hook';
import { Card } from './components/card.component';
import { CardActions } from './components/card-actions.component';

export interface WalletCardProps {
  card?: string;
}

export const WalletCard = ({ card: cardHtml }: WalletCardProps) => {
  const { isImageCard, cardFaces } = useWalletCard(cardHtml);

  const cardsRef = useRef(null);

  if (!cardFaces.length) {
    return null;
  }

  return (
    <Box ref={cardsRef} className="wallet-print-card">
      <StackLayout
        space="$one"
        css={{
          marginInlineStart: 'auto',
          marginInlineEnd: 'auto',
        }}
      >
        {cardFaces.map((cardFace, i) => {
          if (!isImageCard) {
            return (
              <Card
                key={`card-face-${i === 0 ? 'front' : 'back'}`}
                css={{ minHeight: '168px' }}
                width={280}
                dangerouslySetInnerHTML={{
                  __html: cardFace.src,
                }}
              />
            );
          }

          return (
            <Image
              key={`card-face-${i === 0 ? 'front' : 'back'}`}
              maxWidth="100%"
              loading="eager"
              src={cardFace.src}
              alt={cardFace.description}
            />
          );
        })}
        <CardActions cardRef={cardsRef} />
      </StackLayout>
    </Box>
  );
};
